// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatDistanceStrict/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatDistanceStrictWithOptions = convertToFP(fn, 3);
export default formatDistanceStrictWithOptions;